<template lang="pug">
  transition(name="fade-expand-topright")
    .CategoryPopup(@click="close")
      .content(@click.stop)
        .navy-bold-title
          .title
            | {{ title }}
          .seperator

        .form-area

          .top
            .name
              FormItem(
                type="text"
                field_name="name"
                :validate="true"
                :required="true"
                v-model="category.name"
                :label_text=" $t('generic.field.name') "
                :data-vv-as=" $t('generic.field.name') "
                v-validate="'required|max:128'"
                :error="veeErrors.first('name')"
              )
            .description
              FormItem(
                type="text"
                field_name="description"
                :validate="true"
                :required="false"
                v-model="category.description"
                :label_text=" $t('generic.field.description') "
                :data-vv-as=" $t('generic.field.description') "
                v-validate="'max:128'"
                :error="veeErrors.first('description')"
              )
          .bottom
            .parent-toggle
              .label Ebeveyn Gelir Seç
              toggle-button(
                v-model="parentSelectionEnabled"
                :color="'#0087FF'"
              )
            .tree(v-if="parentSelectionEnabled")
              CategoryTree(
                :categories="categories"
                :itemMode="itemMode"
                v-model="selectedCategories"
              )
        .actions
          button.btn.btn-small.btn-line-danger.delete-btn(
            v-if="is_edit"
            type="button"
            @click="openDeleteModal"
          ) {{ $t('generic.action.delete') }}
          LoadingButton.save-btn(
            ref="loadingButton"
            :text=" $t('generic.action.save')  "
            :successText=" $t('generic.msg.registered')  "
            :errorText=" $t('generic.msg.not_register') "
            :loadingText=" $t('generic.msg.registering') "
            :loading="loading"
            :autoBackToNormal="true"
            @click="onSaveClick"
          )
      .loading-overlay(v-if="loading" @click.stop)

      Modal(
        v-if="show_delete_modal"
        :acceptText=" $t('generic.action.delete') "
        :denyText=" $t('generic.action.cancel') "
        type="danger"
        :is_loading="$wait.is('deleteCategory')"
        @onAccept="onDelete"
        @onDeny="closeDeleteModal"
      )
        p {{ $t('generic.msg.confirmation') }}

</template>

<script>

  import { mapState, mapActions } from 'vuex'

  import CategoryTree from "@/component/category-tree"
  import { CategoryTreeItemMode } from '@/component/category-tree/model'
  import { Category } from '@/model/Category'
  import { ToggleButton } from 'vue-js-toggle-button'
  import LoadingButton from '@/component/loading-button'
  import { emptyStringToNull } from '@/utils/helper'
  import _cloneDeep from 'lodash/cloneDeep'

  export default {
    name: "CategoryPopup",

    components: {
      CategoryTree,
      ToggleButton,
      LoadingButton
    },

    data () {
      return {
        category: new Category(),
        parentSelectionEnabled: false,
        loading: false,
        itemMode: CategoryTreeItemMode.TOGGLE,
        selectedCategories: [],
        show_delete_modal: false
      }
    },

    computed: {

      ...mapState('Category', [
        'category_list'
      ]),

      incomeCategoryList () {
        return this.category_list.list.filter(item => !item.is_expense)
      },
      categories () {
        return this.incomeCategoryList
      },

      is_edit () {
        return this.$route.name === 'income-category-edit'
      },

      title () {
        return this.is_edit ? this.$t('generic.action._edit', ['Gelir Türü'])
          : this.$t('generic.action._add', ['Gelir Türü'])
      }

    },

    watch: {
      parentSelectionEnabled () {
        if (!this.parentSelectionEnabled)
          this.selectedCategories = []
      }
    },

    methods: {

      ...mapActions('Category', [
        'createCategory',
        'deleteCategory'
      ]),

      close () {
        this.$router.push({
          name: 'income-category'
        })
      },

      onSaveClick () {
        this.$validator.validateAll().then(result => {
          if (!result) return

          emptyStringToNull(this.category)
          this.category.isExpense = false
          this.loading = true
          this.createCategory({
            item: {
              ...this.category,
              parent_id: this.selectedCategories.length ? this.selectedCategories[0] : null
            },
            edit: this.is_edit
          })
            .then(res => {
              this.close()
              this.loading = false
              // this.showSuccessToast( this.$t('generic.msg.successful') )
            })
            .catch(err => {
              this.loading = false
              if (this.$tc(`error[${err.data.code}]`)) {
                // return this.showErrorToast(this.$t(`error[${err.data.code}]`))
              }
              // this.showErrorToast(err)
            })
        })
      },

      onDelete () {
        this.deleteCategory(this.category.id)
          .then(res => {
              this.close()
              // this.showSuccessToast( this.$t('generic.msg.successful') )
            }
          ).catch(err => {
          if (err.data.code && this.$te(`error[${err.data.code}]`)) {
            // return this.showErrorToast(this.$t(`error[${err.data.code}]`))
          }
          // this.showErrorToast(JSON.stringify(err.data))
        })
      },

      openDeleteModal () {
        this.show_delete_modal = true
      },

      closeDeleteModal () {
        this.show_delete_modal = false
      }

    },

    created () {
      if (this.is_edit) {
        this.category = new Category(_cloneDeep(this.$route.params.category))

        if (this.category.parent_id)
          this.selectedCategories.push(this.category.parent_id)

        this.parentSelectionEnabled = !!(this.selectedCategories.length)
      }
    }

  }
</script>

<style lang="scss" scoped>

  .CategoryPopup {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    overflow-y: auto;

    .content {
      width: 584px;
      padding: 40px;
      box-shadow: 0 2px 20px 0 rgba(57, 61, 68, 0.26);
      background-color: #ffffff;
      position: absolute;
      top: 80px;
      right: 40px;
      border-radius: 3px;

      .form-area {
        .top {
          display: flex;
        }

        .name, .description {
          flex: 0 0 auto;
          width: calc(50% - 13px);
        }

        .name {
          margin-right: 26px;
        }

        .bottom {
          margin-top: 20px;

          .parent-toggle {
            display: flex;

            .label {
              margin-right: 20px;
              color: $color-gray;
            }
          }

          .tree {
            border: 1px solid $color-shadow;
            border-radius: $border-radius;
            margin-top: 20px;
            max-height: 300px;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 0px;
              height: 10px;
            }
          }

        }
      }

      .actions {
        display: flex;
        align-items: center;
        margin-top: 22px;


        .delete-btn {
          flex: 1 0 30%;
          height: 42px;
          margin-right: 20px;
        }

        .save-btn {
          flex: 1 0 70%;
          width: 100%;
          height: 42px;
        }
      }


      .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }

      .navy-bold-title {
        font-size: 17px;
        font-weight: 500;
        color: $color-navy;
      }

      .seperator {
        width: 100%;
        height: 1px;
        background-color: $color-shadow;
        margin-top: 15px;
        margin-bottom: 22px;
      }
    }
  }

</style>

